<template>
  <div>
    <el-drawer
      :title="title"
      :visible.sync="drawer"
      size="80%"
      :wrapperClosable="false"
    >
      <div class="div" v-loading="loading">
        <div class="div-center">
          <el-table
            :data="tableData"
            ref="table"
            style="width: 100%"
            height="calc(100% - 40px)"
          >
            <el-table-column label="序号" width="50" type="index">
            </el-table-column>
            <el-table-column
              label="工单编号"
              align="center"
              prop="Code"
              sortable
            >
            </el-table-column>
            <el-table-column
              label="设备编号"
              align="center"
              prop="DeviceItemCode"
              sortable
            >
            </el-table-column>
            <el-table-column
              label="设备名称"
              align="center"
              prop="DeviceItemName"
              sortable
            >
            </el-table-column>
            <el-table-column
              label="工单类型"
              align="center"
              prop="WorkOrderTypeName"
              sortable
            >
            </el-table-column>
            <el-table-column
              label="类型"
              align="center"
              prop="TypeName"
              sortable
            >
            </el-table-column>
            <el-table-column
              label="工单日期"
              align="center"
              prop="WorkOrderDate"
              sortable
            >
              <template slot-scope="scope">
                {{
                  scope.row.WorkOrderDate
                    ? moment(scope.row.WorkOrderDate).format('YYYY-MM-DD')
                    : ''
                }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="80">
              <template slot-scope="scope">
                <el-button type="text" @click="handleView(scope.row)"
                  >详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div
            style="
              height: 40px;
              display: flex;
              align-items: center;
              justify-content: right;
            "
          >
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pagination.PageIndex"
              :page-sizes="pagination.PageSizes"
              :page-size="pagination.PageRows"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pagination.total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </el-drawer>
    <EditForm ref="EditForm"></EditForm>
  </div>
</template>
<script>
import moment from 'moment'
import EditForm from '@/views/Operation/OperationWorkOrder/EditForm'

export default {
  data() {
    return {
      moment,
      row: {},
      drawer: false,
      searchData: {
        Condition: 'Name',
        Keyword: '',
      },
      tableData: [],
      pagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 40, 60, 100],
        total: 0,
      },
      selectedRows: [],
      loading: false,
      title: '',
      rowId: '',
    }
  },
  props: {},
  components: { EditForm },
  methods: {
    handleView(row) {
      this.$refs.EditForm.openForm('工单详情', row, true)
    },
    openList(title, row) {
      this.title = title
      this.drawer = true
      this.row = row
      this.getDataList()
      // this.searchData.Keyword = "";
      // this.pagination.PageIndex = 1;
      // if (id) {
      //   this.rowId = id;
      //   this.getDataList();
      // }
    },
    handleSelect(selection) {
      this.selectedRows = selection
    },
    getDataList() {
      this.selectedRows = []
      this.loading = true
      this.$http
        .post(`/Base_DeviceTreeManage/Device_WorkOrder/GetWorkOrderDataList`, {
          PageIndex: this.pagination.PageIndex,
          PageRows: this.pagination.PageRows,
          SortField: 'CreateTime',
          SortType: 'Desc',
          Search: [
            {
              Condition: 'TaskPlanDetailsId',
              Keyword: this.row.DetailId || '',
            },
          ],
        })
        .then((resJson) => {
          this.loading = false
          this.tableData = resJson.Data
          this.pagination.total = resJson.Total
          this.$nextTick(() => {
            if (this.$refs.table) {
              this.$refs.table.clearSelection()
            }
          })
        })
    },
    handleSearch() {
      this.pagination.PageIndex = 1
      this.getDataList()
    },
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex
      this.getDataList()
    },
    handleSizeChange(PageRows) {
      this.pagination.PageIndex = 1
      this.pagination.PageRows = PageRows
      this.getDataList()
    },
    handleAdd() {
      this.$refs.EditForm.openForm('新建货架', {
        AreaId: this.rowId,
      })
    },
    handleDetele(rows) {
      let ids = rows.map((item) => item.Id)
      this.$confirm(`此操作将永久删除该货架, 是否继续?`, {
        type: 'warning',
      })
        .then(() => {
          this.loading = true
          this.$http.post('/PB/PB_Rack/DeleteData', ids).then((resJson) => {
            this.loading = false
            if (resJson.Success) {
              this.$notify.success('删除成功')
              this.getDataList()
            } else {
              this.$notify.error(resJson.Msg)
            }
          })
        })
        .catch(() => {})
    },
    handleEdit(row) {
      this.$refs.EditForm.openForm('编辑货架', row)
    },
  },
  mounted() {},
  created() {},
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
.div-top,
.div-search {
  // height: 30px;
  line-height: 30px;
}
.div-search {
  margin-top: 10px;
}
.div-center {
  margin-top: 10px;
  height: calc(100% - 30px);
}
.title {
  font-size: 20px;
  font-weight: bold;
  line-height: 40px;
}
::v-deep .el-drawer__header {
  margin: 0;
  padding: 20px;
  font-weight: bold;
  font-size: 20px;
}
</style>
